import { useAppStore } from '@indipia/shared';

export interface WorkTypeItem {
  code: string;
  codeName: string;
}

// ZEU_WORK_TYPE 코드 저장소 로드 전 fallback
// TODO: appStore init 완료 후 자동으로 대체됨 — fallback 유지 필수
const FALLBACK: WorkTypeItem[] = [
  { code: 'BATHROOM', codeName: '욕실기구 설치' },
  { code: 'CARPENTRY', codeName: '목공' },
  { code: 'CLEANING',  codeName: '입주청소' },
  { code: 'DEMOLISH',  codeName: '철거' },
  { code: 'ELECTRIC',  codeName: '전기(배선)' },
  { code: 'FILM',      codeName: '필름·유리' },
  { code: 'FLOORING',  codeName: '마루' },
  { code: 'FURNITURE', codeName: '가구·가전' },
  { code: 'KITCHEN',   codeName: '주방(싱크대)' },
  { code: 'LIGHTING',  codeName: '조명·전기마감' },
  { code: 'PAINT',     codeName: '도장(페인트)' },
  { code: 'PLASTER',   codeName: '미장·방수' },
  { code: 'PLUMBING',  codeName: '설비(배관)' },
  { code: 'SILICON',   codeName: '실리콘·코킹' },
  { code: 'TILE',      codeName: '타일' },
  { code: 'WALLPAPER', codeName: '도배' },
  { code: 'WINDOW',    codeName: '창호(샷시)' },
  { code: 'WOODDOOR',  codeName: '목창호(방문)' },
];

/** ZEU_WORK_TYPE 코드 목록. appStore 로드 전에는 fallback 반환. */
export function useWorkTypes(): WorkTypeItem[] {
  // s.codes 참조 자체를 선택 — 함수 호출 결과(새 배열)를 선택하면 매 렌더마다 참조가 달라져 무한 루프 발생
  const codes = useAppStore((s) => s.codes);
  const filtered = codes.filter((c) => c.codeGroupCode === 'ZEU_WORK_TYPE');
  if (filtered.length > 0) {
    return filtered
      .slice()
      .sort((a, b) => a.codeOrder - b.codeOrder)
      .map((c) => ({ code: c.codeValue, codeName: c.codeName }));
  }
  return FALLBACK;
}
